'use client';

import { useEffect, useState } from 'react';
import ImageView from '../../../../components/ui/ImageView/ImageView';
import type { LotteryDetailKvProps } from '../../types';
import goodsmilekujiStyles from './LotteryDetailKv.goodsmilekuji.module.scss';
import styles from './LotteryDetailKv.module.scss';

function LotteryDetailKv({ pcKvUrl, spKvUrl, variant = 'default' }: LotteryDetailKvProps) {
  const [isShowSp, setIsShowSp] = useState(false);
  const [isSpkv, setIsSpkv] = useState(false);

  // variantに応じてスタイルを決定
  const currentStyles = variant === 'goodsmilekuji' ? goodsmilekujiStyles : styles;

  useEffect(() => {
    const handleResize = () => {
      const innerWidth = window ? window.innerWidth : 0;
      setIsShowSp(innerWidth < 600);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    setIsSpkv(true);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className={currentStyles.componentStyle}>
      {isSpkv && <ImageView src={isShowSp ? spKvUrl : pcKvUrl} isFreeSize />}
    </div>
  );
}

export default LotteryDetailKv;
